/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-escape */
import React, { useEffect, useState } from "react";
import {
  VmoButton,
  VmoCard,
  VmoCardContent,
  VmoCardDescription,
  VmoContainer,
  VmoGrid,
  VmoGridColumn,
  VmoGridRow,
  VmoImage,
} from "vmo-library";
import { allProduct, apiCall, getService } from "../AppUtill";
import vmoLogo from "../svg/logo.svg";

function SignIn() {
  const [data, setData] = useState([]);
  const [list, setList] = useState(allProduct);
  console.log(list);

  const subDomainRegex = /(?:http[s]*\:\/\/)*(.*?)\.(?=[^\/]*\..{2,5})/i;
  const subDomain = window.location.host.split(".")[0];

  // NOTE :- Once all veemo product is live then uncomment this getUrl function and delete below getServideUrl and getUrl function
  // const getUrl = (service) => {
  //   if (window.location.hostname.match(subDomainRegex) === null) {
  //     return `https://${process.env.REACT_APP_DOMAIN}/${getService(
  //       service
  //     )}/signin`;
  //   }
  //   return `https://${subDomain}.${process.env.REACT_APP_DOMAIN}/${getService(
  //     service
  //   )}/signin`;
  // };

  // NOTE :- once all veemo product is live in production then delete this funciton
  const getServiceUrl = (service) => {
    switch (service) {
      case "desk":
        return process.env.REACT_APP_SUPPORT_DOMAIN;
      case "chat":
        return process.env.REACT_APP_CHAT_DOMAIN;
      case "crm":
        return process.env.REACT_APP_CRM_DOMAIN;
      case "talk":
        return process.env.REACT_APP_TALK_DOMAIN;
      case "guide":
        return process.env.REACT_APP_GUIDE_DOMAIN;
      case "survey":
        return process.env.REACT_APP_SURVEY_DOMAIN;

      default:
        return null;
    }
  };

  // NOTE :- once all veemo product is live in production then delete this funciton
  const getUrl = (service) => {
    if (window.location.hostname.match(subDomainRegex) === null) {
      return `https://${getServiceUrl(service)}/signin`;
    }
    return `https://${subDomain}.${getServiceUrl(service)}/signin`;
  };

  const getBtnName = (Service) => {
    const allLocalKeys = Object.entries(localStorage).map((d) => d[0]);

    if (allLocalKeys.includes(getService(Service))) return "Open";
    return "Sign In";
  };

  useEffect(() => {
    if (window.location.hostname.match(subDomainRegex) !== null) {
      apiCall({
        url: `products?domain=${subDomain}`,
        onSuccess: (payload) => {
          setData(payload);
        },
        onFailure: () => {
          window.location.replace("https://veemosupport.xyz/signin");
        },
      });
    }
  }, []);

  useEffect(() => {
    if (data.length > 0) {
      const subscribedProduct = allProduct.filter(({ head: service1 }) =>
        data.some((service2) => service2 === service1)
      );

      setList(subscribedProduct);
    }
  }, [data]);

  return (
    <VmoContainer className="product-container">
      <div className="d-flex">
        <VmoImage src={vmoLogo} className="veemo-logo" />
        {/* {window.location.hostname.match(subDomainRegex) === null && (
          <span className="sign-up-link">
            Don't have an account?
            <a href="https://veemo.io/signup"> Sign up</a>
          </span>
        )} */}
      </div>

      <VmoGrid columns={2} relaxed centered stackable>
        <VmoGridRow>
          <div className="product-body">
            <h3>Time to Create Change</h3>
            <h5>
              Explore the veemo products dedicated to improve your interaction
              with your precious customers in a simplified yet efficient way and
              also including all the widely used and better features. You are
              just a single click away :)
            </h5>
          </div>
        </VmoGridRow>

        <VmoGridRow className="product-grid">
          {list.map((data, i) => (
            <VmoGridColumn width="equal" key={i}>
              <VmoCard fluid key={i}>
                <VmoCardContent className="product-card">
                  <div className="d-flex mb-3">
                    <h4>Veemo {getService(data.head)} </h4>
                    <VmoButton
                      className="basic-fill-btn"
                      href={getUrl(data.head)}
                      target="_blank"
                      size="small"
                      rel="noopener noreferrer"
                    >
                      {getBtnName(data.head)}
                    </VmoButton>
                  </div>
                  <VmoCardDescription>{data.subHead}</VmoCardDescription>
                </VmoCardContent>
              </VmoCard>
            </VmoGridColumn>
          ))}
        </VmoGridRow>
      </VmoGrid>
    </VmoContainer>
  );
}

export { SignIn };
